module.exports = __webpack_public_path__ + "static/media/AuthBackground.c6116ec9.png";